module.exports = __webpack_public_path__ + "img/star.cd2cd99c.svg";